export const GET_CUSTOMERS_API_IS_PENDING = "GET_CUSTOMERS_API_IS_PENDING";
export const GET_CUSTOMERS_API_IS_ERROR = "GET_CUSTOMERS_API_IS_ERROR";

export const GET_CUSTOMERS = "GET_CUSTOMERS";
export const GET_CUSTOMER = "GET_CUSTOMER";
export const GET_CUSTOMERS_IS_SUCCESS = "GET_CUSTOMERS_IS_SUCCESS";
export const GET_CUSTOMERS_FTSEARCH_IS_SUCCESS =
  "GET_CUSTOMERS_FTSEARCH_IS_SUCCESS";
export const GET_CUSTOMER_IS_SUCCESS = "GET_CUSTOMER_IS_SUCCESS";
